import { APIClientError } from './api-client-error';

export type TypeCloudflareReason = 'tunnel' | 'worker' | 'unknown';

export class CloudflareError extends APIClientError {
  public readonly reason: TypeCloudflareReason;

  public constructor({
    status,
    path,
    reason = 'unknown',
  }: {
    status?: number;
    path?: string;
    reason?: TypeCloudflareReason;
  }) {
    super('Cloudflare error', status, undefined, path);
    this.name = 'CloudflareError';
    this.reason = reason;
  }
}
